<template>
  <div class="local-attractions">
    <section v-if="nearbyActivities" class="nearby-activities">
      <div
        class="preserve-linebreaks"
        data-g-translate="nearby-activities"
        v-text="nearbyActivities"
      />
      <lazy-google-translate-button
        v-if="needsTranslation"
        format="text"
        query-selector-value="nearby-activities"
      />
    </section>

    <slot name="water-quality" />

    <template v-if="isUK">
      <slot name="visit-britain" />
      <slot name="national-trust" />
      <campsite-cycle-routes :point="point" />
      <slot name="activities-list" />
      <slot name="festivals" />

      <distances-note />
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { LatLng } from '~/utility/geo/GeoLocation'

@Component
class CampsiteLocalAttractions extends Vue {
  @Prop()
  point: LatLng

  @Prop()
  nearbyActivities: string

  @Prop({ default: false })
  needsTranslation: boolean

  @Prop()
  campsiteHierarchyCountry: string

  get isUK() {
    return ['England', 'Scotland', 'Wales', 'Northern Ireland'].includes(
      this.campsiteHierarchyCountry,
    )
  }
}

export default toNative(CampsiteLocalAttractions)
</script>

<style scoped>
.local-attractions :deep(.poi) {
  margin: 0 0 0.35em 0;
}

.local-attractions :deep(.poi .distance) {
  white-space: nowrap;
  color: var(--colour-text-light);
  font-size: var(--small);
}

.local-attractions :deep(.poi .distance:after) {
  content: ')';
}

.local-attractions :deep(.poi .distance:before) {
  content: '(';
}

.local-attractions :deep(section) {
  margin: 1em 0 2em;
  position: relative;
  font-size: var(--body);
}
</style>
